import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
type Field = FieldRenderProps<string, HTMLInputElement> & {
  label: string;
};
export function CheckboxInput(props) {
  const $ = _c(26);
  const hasError = props.meta.error && props.meta.touched;
  const errorId = `${props.input.name}-error`;
  let t0;
  if ($[0] !== props.className) {
    t0 = mergeClasses(props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.input.disabled && "cursor-not-allowed opacity-50";
  let t2;
  if ($[2] !== t1) {
    t2 = mergeClasses("flex gap-2", t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = props.hideLabel ? props.label : "";
  const t4 = hasError ? errorId : undefined;
  const t5 = hasError ? "true" : "false";
  let t6;
  if ($[4] !== props.input || $[5] !== props.label || $[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = <input {...props.input} type="checkbox" placeholder={t3} aria-label={props.label} aria-describedby={t4} aria-invalid={t5} id={props.input.name} className="peer border-light-gray-500 relative mt-1 h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-md border-2 bg-white transition checked:border-0 checked:bg-blue-500" checked={props.input.checked} disabled={props.input.disabled} data-clarity-mask="true" />;
    $[4] = props.input;
    $[5] = props.label;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== props.input.name || $[11] !== props.label) {
    t7 = <label htmlFor={props.input.name} className="cursor-pointer">{props.label}</label>;
    $[10] = props.input.name;
    $[11] = props.label;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="pointer-events-none absolute mt-[6px] ml-[2px] hidden h-4 w-4 cursor-pointer text-white peer-checked:block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t2 || $[15] !== t6 || $[16] !== t7) {
    t9 = <div className={t2}>{t6}{t7}{t8}</div>;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== errorId || $[19] !== hasError || $[20] !== props.meta.error) {
    t10 = hasError && <ErrorMessage error={props.meta.error} id={errorId} />;
    $[18] = errorId;
    $[19] = hasError;
    $[20] = props.meta.error;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t0 || $[23] !== t10 || $[24] !== t9) {
    t11 = <div className={t0}>{t9}{t10}</div>;
    $[22] = t0;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}